<template>
  <div>
    <div class="" v-if="isPropertyLoading || isUserLoading"><Loading /></div>
    <div v-else-if="!property?.isActive">
      <h1>Not Found</h1>
      <p>Please check your link and try again</p>
    </div>
    <div v-else-if="isAdmin" class="flex flex-col h-screen">
      <Disclosure as="nav" class="bg-gray-800" v-slot="{ open }">
        <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div class="flex items-center justify-between h-16">
            <div class="flex items-center">
              <div class="shrink-0">
                <router-link :to="`/${siteCode}/admin`">
                  <img class="" src="/AKLogoCropClear.png" alt="logo" />
                </router-link>
              </div>
              <div class="hidden md:block">
                <div class="flex items-baseline ml-10 space-x-4">
                  <router-link
                    v-for="item in navigation"
                    :key="item.name"
                    :to="item.href"
                    :class="[
                      item.current
                        ? 'bg-gray-900 text-white'
                        : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                      'px-3 py-2 rounded-md text-sm font-medium',
                      item.name == 'Alert' ? 'bg-red-800 hover:bg-red-600' : '',
                    ]"
                    :aria-current="item.current ? 'page' : undefined"
                  >
                    {{ item.name }}
                  </router-link>
                </div>
              </div>
            </div>
            <div class="hidden md:block">
              <div class="flex items-center ml-4 md:ml-6">
                <div
                  v-if="adminNote.note?.length && adminNote.note.length > 0"
                  class="text-gray-300 cursor-pointer"
                  @click="toggleAdminNote"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-8 h-8"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                    />
                  </svg>
                </div>
                <!-- <button

                type="button"
                class="p-1 text-gray-400 bg-gray-800 rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
              >
                <span class="sr-only">View notifications</span>
                <i-heroicons-outline-bell class="w-6 h-6" aria-hidden="true" />
              </button> -->

                <!-- Profile dropdown -->
                <Menu as="div" class="relative ml-3">
                  <div>
                    <MenuButton
                      class="flex items-center max-w-xs text-sm bg-gray-800 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                    >
                      <span class="sr-only">Open user menu</span>
                      <i-heroicons-outline-user class="block w-6 h-6 text-gray-400" />
                    </MenuButton>
                  </div>
                  <transition
                    enter-active-class="transition duration-100 ease-out"
                    enter-from-class="transform scale-95 opacity-0"
                    enter-to-class="transform scale-100 opacity-100"
                    leave-active-class="transition duration-75 ease-in"
                    leave-from-class="transform scale-100 opacity-100"
                    leave-to-class="transform scale-95 opacity-0"
                  >
                    <MenuItems
                      class="absolute right-0 w-48 py-1 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                    >
                      <MenuItem key="Profile" v-slot="{ active }">
                        <router-link
                          key="Profile"
                          :to="`/${bldgStore.siteCode}/account`"
                          :class="[
                            active ? 'bg-gray-100' : '',
                            'block px-4 py-2 text-sm text-gray-700',
                          ]"
                          >Profile</router-link
                        >
                      </MenuItem>
                      <MenuItem key="Logout" v-slot="{ active }">
                        <a
                          key="Logout"
                          @click="logout"
                          :class="[
                            active ? 'bg-gray-100' : '',
                            'block px-4 py-2 text-sm text-gray-700',
                          ]"
                        >
                          Log out
                        </a>
                      </MenuItem>
                    </MenuItems>
                  </transition>
                </Menu>
              </div>
            </div>
            <div class="flex -mr-2 md:hidden">
              <!-- Mobile menu button -->
              <DisclosureButton
                class="inline-flex items-center justify-center p-2 text-gray-400 bg-gray-800 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
              >
                <span class="sr-only">Open main menu</span>
                <i-heroicons-outline-menu
                  v-if="!open"
                  class="block w-6 h-6"
                  aria-hidden="true"
                />
                <i-heroicons-outline-x v-else class="block w-6 h-6" aria-hidden="true" />
              </DisclosureButton>
            </div>
          </div>
        </div>

        <DisclosurePanel class="md:hidden">
          <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <router-link
              v-for="item in navigation"
              :key="item.name"
              :to="item.href"
              :class="[
                item.current
                  ? 'bg-gray-900 text-white'
                  : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                'block px-3 py-2 rounded-md text-base font-medium',
              ]"
              :aria-current="item.current ? 'page' : undefined"
            >
              {{ item.name }}
            </router-link>
          </div>
          <div class="pt-4 pb-3 border-t border-gray-700">
            <div class="flex items-center px-5">
              <div class="shrink-0">
                <i-heroicons-outline-user class="block w-6 h-6 text-white" />
              </div>
              <div class="ml-3">
                <div class="text-base font-medium leading-none text-white">
                  {{ user?.firstName }} {{ user?.lastName }}
                </div>
                <div class="text-sm font-medium leading-none text-gray-400">
                  {{ user?.loginEmail }}
                </div>
              </div>
              <!-- <button
              type="button"
              class="shrink-0 p-1 ml-auto text-gray-400 bg-gray-800 rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
            >
              <span class="sr-only">View notifications</span>
              <i-heroicons-outline-bell class="w-6 h-6" aria-hidden="true" />
            </button> -->
            </div>
            <div class="px-2 mt-3 space-y-1">
              <router-link
                :to="`/${bldgStore.siteCode}/account`"
                class="block px-3 py-2 text-base font-medium text-gray-400 rounded-md hover:text-white hover:bg-gray-700"
                >Profile</router-link
              >

              <a
                @click="logout"
                class="block px-3 py-2 text-base font-medium text-gray-400 rounded-md hover:text-white hover:bg-gray-700"
                >Log out</a
              >
            </div>
          </div>
        </DisclosurePanel>
      </Disclosure>
      <main class="flex flex-1">
        <main class="flex flex-col flex-1">
          <header class="bg-white shadow block">
            <div class="px-4 py-6 mx-auto max-w-7xl sm:px-6 lg:px-8">
              <h1 class="text-3xl font-bold text-gray-900">
                <template v-if="includePageInHeader">
                  {{ header || page }}
                  {{ user?.isTenantAdmin ? user?.tenantName : property?.name }}
                </template>
                <template v-else>
                  {{ header || page }}
                </template>
              </h1>
            </div>
          </header>
          <main class="flex-grow bg-white">
            <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
              <div
                v-if="!isLatestVersion"
                @click="reload"
                class="version-warning p-8 bg-yellow-100 border border-yellow-600 font-serif"
              >
                <div class="my-2 text-2xl">Update Available</div>
                <div class="text-lg">
                  Please reload page to download the latest version.
                </div>
                <div>
                  <button
                    class="mt-5 text-sm font-medium py-2 px-4 text-yellow-900 bg-yellow-200 border border-transparent rounded-md hover:bg-yellow-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-yellow-500"
                    @click="reload"
                  >
                    Reload Page
                  </button>
                </div>
                <div class="mt-5 font-serif">
                  A new version is available on the server. Please reload your browser (or
                  click reload button) to download the latest version. Some functionality
                  may not work when local version is out of date.

                  <div class="ml-2 font-mono mt-4">
                    <div>
                      Available Version:
                      <span class="font-bold">
                        {{ serverVersion }}
                      </span>
                    </div>
                    <div>
                      Current Version: &nbsp;
                      <span class="font-bold">
                        {{ clientVersion }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Admin content -->
              <div class="px-4 sm:px-0">
                <slot></slot>
              </div>
              <!-- /End Admin Content -->
            </div>
          </main>
        </main>
        <!-- staffnote sidebar-->
        <aside
          v-if="isAdminNoteOpen"
          :class="
            isAdminNoteOpen ? '-translate-x-0 ease-in' : 'translate-x-full ease-out'
          "
          class="sticky h-full right-0 top-0 w-[25em] p-4 border-l border-gray-300 bg-white transition duration-150 transform"
          :style="{ height: noteSidebarHeight }"
        >
          <div v-if="adminNote" class="flex flex-col h-full">
            <p class="richText" v-html="adminNote.note" />
          </div>
        </aside>
      </main>

      <footer class="p-4 bg-gray-200">
        <div class="flex flex-row">
          <div class="flex-grow font-serif text-sm text-gray-800">
            Copyright &copy; AK Preparedness, LLC {{ new Date().getFullYear() }}
          </div>
          <div class="px-4 pt-1 font-mono text-sm text-gray-800 bg-gray-300">
            {{ version }}
          </div>
        </div>
      </footer>
    </div>
    <div v-else>Admin permissions for this page are required</div>
  </div>
</template>

<script setup lang="ts">
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/vue";
import { useBldgStore } from "../store/bldgStore";
import { useUserStore } from "../store/userStore";
import { AdminNoteDTO, PermissionType, PortalDTO } from "../store/generatedFetchClient";
import { useAdminStore } from "../store/adminStore";

const bldgStore = useBldgStore();
var userStore = useUserStore();
var router = useRouter();
const adminStore = useAdminStore();

var isAdmin = computed(() => userStore.isAdmin);
const hasPermission = userStore.hasPermission;
let user = computed(() => userStore.user);
var isUserLoading = computed(() => userStore.isUserLoading);
var isLoggedIn = computed(() => userStore.isLoggedIn);
var isUserLoadedFromServer = computed(() => userStore.isUserLoadedFromServer);

var isAlertEnabled = computed(() => bldgStore.building?.isAlertEnabled ?? false);
var isRespondEnabled = computed(() => bldgStore.building?.isRespondEnabled ?? false);

var serverVersion = computed(() => bldgStore.serverVersion);
var clientVersion = import.meta.env.VITE_SAFETYNET_VERSION;
var isLatestVersion = computed(() => {
  console.log(`Client version: ${clientVersion},  server version ${serverVersion.value}`);
  return !serverVersion.value || serverVersion.value == clientVersion;
});

const emit = defineEmits<{
  (event: "selectedProperty", property: PortalDTO): void;
}>();

let property = computed(() => bldgStore.property);
var isPropertyLoading = computed(() => bldgStore.isLoading);
let siteCode = computed(() => bldgStore.property?.siteCode ?? "");
watch(property, emitProperty);

function emitProperty() {
  console.log("emitProperty");
  console.log(property.value);
  if (property.value) {
    emit("selectedProperty", property.value);
  }
}
onMounted(async () => await loadData());
watch(property, loadData);
async function loadData() {
  bldgStore.getServerVersion();
  if (property?.value?.portalId) {
    try {
      await userStore.getUser(property.value.siteCode!, property.value.portalId!, false);
      console.log("Admin Layout> User load complete", user.value);
    } catch (e: any) {
      console.warn("Admin Layout> Error loading user", e);
    }
  }
}

watch(isUserLoadedFromServer, redirectIfNotLoggedIn);
function redirectIfNotLoggedIn() {
  // If user loading attempt is complete
  //    and we're still not logged in,
  //  then redirect to login page
  if (property.value && userStore.isUserLoadedFromServer && !isLoggedIn.value) {
    console.log(
      "Admin Layout> redirecting to login page. isLoggedIn=" + isLoggedIn.value
    );
    router.push(
      `/${property.value.siteCode}/login?returnUrl=/${property.value.siteCode}/admin`
    );
    // } else {
    //   console.log(
    //     "Admin Layout NOT redirecting to login page. isLoggedIn=" +
    //       isLoggedIn.value +
    //       ", userLoadcomplete=" +
    //       userStore.isUserLoadedFromServer
    //   );
  }
}

//emit("selectedProperty", computed(() => bldgStore.property).value);

const props = defineProps({
  page: {
    type: String,
    required: false,
    default: "Admin Home",
    validator: function (value: string) {
      return [
        "Admin Home",
        "Users",
        "Reports",
        "Tests",
        "Alert",
        "Documents",
        "Emergency Contacts",
        "Respond Editor",
        "Tenants",
      ].includes(value);
    },
  },
  title: {
    type: String,
    required: false,
  },
  header: {
    type: String,
    required: false,
  },
  includePageInHeader: {
    type: Boolean,
    required: false,
    default: true,
  },
});

// Sets document.title. A <title> element used to sit in this template, but a <title>
// outside <head> is inert, so tabs showed the raw URL instead. Same format as before.
useTitle(
  computed(() => {
    const scope = user.value?.isTenantAdmin
      ? user.value?.tenantName
      : property.value?.name;
    return [props.title, "Admin", scope].filter(Boolean).join(" - ");
  })
);

let navigation = computed<{ name: string; href: string; current: boolean }[]>(() => {
  //console.log(`Current page is ${props.page}`);
  let viewableNavPages: { name: string; href: string; current: boolean }[] = [];

  viewableNavPages.push({
    name: "Back to Training Site",
    href: `/${siteCode.value}`,
    current: false,
  });

  viewableNavPages.push({
    name: "Admin Home",
    href: `/${siteCode.value}/admin`,
    current: props.page == "Admin Home",
  });

  if (isAlertEnabled.value && hasPermission(PermissionType.SendAlerts)) {
    viewableNavPages.push({
      name: "Alert",
      href: `/${siteCode.value}/admin/alert`,
      current: props.page == "Alert",
    });
  }

  if (hasPermission(PermissionType.EditContacts)) {
    viewableNavPages.push({
      name: "Contacts",
      href: `/${siteCode.value}/admin/contacts`,
      current: props.page == "Emergency Contacts",
    });
  }

  if (hasPermission(PermissionType.EditDocuments)) {
    console.log("User has Edit-Document permission");
    viewableNavPages.push({
      name: "Documents",
      href: `/${siteCode.value}/admin/docs`,
      current: props.page == "Documents",
    });
  }

  if (isRespondEnabled.value && hasPermission(PermissionType.EditRespond)) {
    viewableNavPages.push({
      name: "Respond",
      href: `/${siteCode.value}/admin/respond`,
      current: props.page == "Respond Editor",
    });
  }

  if (hasPermission(PermissionType.EditTenant)) {
    viewableNavPages.push({
      name: "Tenants",
      href: `/${siteCode.value}/admin/tenants`,
      current: props.page == "Tenants Editor",
    });
  }

  if (hasPermission(PermissionType.ViewUsers)) {
    viewableNavPages.push({
      name: "Users",
      href: `/${siteCode.value}/admin/users`,
      current: props.page == "Users",
    });
  }

  return viewableNavPages;
  /*return [
    {
      name: "Users",
      href: `/${siteCode.value}/admin/users`,
      current: props.page == "Users",
    },
    {
      name: "Tests",
      href: `/${siteCode.value}/admin/tests`,
      current: props.page == "Tests",
    },
    {
      name: "Reports",
      href: `/${siteCode.value}/admin/reports`,
      current: props.page == "Reports",
    },
    {
      name: "Alert",
      href: `/${siteCode.value}/admin/alert`,
      current: props.page == "Alert",
    },
  ];*/
});

// const userNavigation = [
//   { name: "Profile", href: "#" },
//   { name: "Sign out", href: "#" },
// ];

const isAdminNoteOpen = ref(false);
const adminNote = ref({ page: "", note: "" } as AdminNoteDTO);
const noteSidebarHeight = ref("100vh");

window.addEventListener("scroll", calculateNoteSidebarHeight);

function calculateNoteSidebarHeight() {
  const scrollPosition = window.scrollY;
  const maxScroll = document.documentElement.scrollHeight - window.innerHeight;

  const header = document.querySelector("header");
  const footer = document.querySelector("footer");

  const headerHeight = header ? header.clientHeight : 0;
  const footerHeight = footer ? footer.clientHeight : 0;

  const headerVisibleHeight = Math.max(headerHeight - scrollPosition, 0);
  const footerVisibleHeight = Math.max(footerHeight - (maxScroll - scrollPosition), 0);

  noteSidebarHeight.value = `calc(100vh - ${headerVisibleHeight}px - ${footerVisibleHeight}px)`;
}

async function toggleAdminNote() {
  if (isAdminNoteOpen.value) {
    isAdminNoteOpen.value = false;
  } else {
    calculateNoteSidebarHeight();
    isAdminNoteOpen.value = true;
  }
}

onMounted(getAdminNote);
async function getAdminNote() {
  console.log("getting admin note: ", props.page);
  adminNote.value = await adminStore.getAdminNote(
    props.page,
    user.value!.isTenantAdmin ?? false,
    property.value!.portalId!
  );
}

async function logout() {
  await userStore.logoff();
  console.log("User successfully logged out");
  router.push("/" + bldgStore.siteCode);
}

function reload() {
  document.location.reload();
}

const version = import.meta.env.VITE_SAFETYNET_VERSION;
</script>

<style scoped>
.richText h1 {
  display: block;
  font-size: 2em;
  margin-top: 0.67em;
  margin-bottom: 0.67em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}
.richText h2 {
  display: block;
  font-size: 1.5em;
  margin-top: 0.83em;
  margin-bottom: 0.83em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}
.richText h3 {
  display: block;
  font-size: 1.17em;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}
.richText h4 {
  display: block;
  margin-top: 1.33em;
  margin-bottom: 1.33em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}
.richText h5 {
  display: block;
  font-size: 0.83em;
  margin-top: 1.67em;
  margin-bottom: 1.67em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}
.richText h6 {
  display: block;
  font-size: 0.67em;
  margin-top: 2.33em;
  margin-bottom: 2.33em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

.richText {
  font-size: medium;
}

.richText :deep(a) {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.richText :deep(a:hover) {
  color: cornflowerblue;
}

.richText :deep(ul) {
  padding-left: 24px;
}

.richText :deep(ul > li) {
  font-weight: normal;
  list-style-type: circle !important;
}

.richText :deep(ol) {
  counter-reset: li;
  margin-left: 0;
  padding-left: 0;
}

.richText :deep(ol > li) {
  position: relative;
  margin: 0 0 2px 2em;
  padding: 0 8px;
  list-style: none;
}

.richText :deep(ol > li:before) {
  content: counter(li);
  counter-increment: li;
  position: absolute;
  top: 0px;
  left: -1em;
  box-sizing: border-box;
}

.richText :deep(h2) {
  font-size: x-large;
}

.richText :deep(h3) {
  font-size: larger;
}

.richText :deep(h4) {
  font-size: large;
}
</style>
